import { render, staticRenderFns } from "./SubMenuLayout.vue?vue&type=template&id=3ac93222"
import script from "./SubMenuLayout.vue?vue&type=script&lang=js"
export * from "./SubMenuLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports